import { autoUpdate, flip, offset, shift, size, useFloating } from '@floating-ui/vue'
import { computed, ref } from 'vue'

export function useDropdownAnchor(options = {}) {
  const reference = ref(null)
  const floating = ref(null)

  const setReference = el => {
    reference.value = el?.$el ?? el ?? null
  }
  const setFloating = el => {
    floating.value = el?.$el ?? el ?? null
  }

  const { floatingStyles, isPositioned } = useFloating(reference, floating, {
    placement: options.placement ?? 'bottom-start',
    strategy: 'fixed',
    transform: false,
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(options.offset ?? 8),
      flip({ padding: 8 }),
      shift({ padding: 8 }),
      size({
        padding: 8,
        apply({ availableWidth, availableHeight, rects, elements }) {
          const maxHeight =
            typeof options.maxHeight === 'number' ? Math.min(availableHeight, options.maxHeight) : availableHeight
          Object.assign(elements.floating.style, {
            maxWidth: `${Math.round(availableWidth)}px`,
            maxHeight: `${Math.round(maxHeight)}px`,
            ...(options.matchReferenceWidth ? { width: `${Math.round(rects.reference.width)}px` } : {})
          })
        }
      })
    ]
  })

  const anchoredStyles = computed(() => ({
    ...floatingStyles.value,
    visibility: isPositioned.value ? 'visible' : 'hidden',
    transition: 'none'
  }))

  return { setReference, setFloating, floatingStyles: anchoredStyles }
}
